import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';

import getPluginKey from './getPluginKey';
import ReferencePickerPlugin from '../types/ReferencePickerPlugin';

const REFERENCE_PICKER_CONTEXT_PREFIX = '__REFERENCE_PICKER_CONTEXT__';

export const getContextKey = (plugin: ReferencePickerPlugin<unknown>) =>
  `${REFERENCE_PICKER_CONTEXT_PREFIX}${getPluginKey(plugin)}`;

export const getOrCreatePluginContext = (
  plugin: ReferencePickerPlugin<unknown>,
) => {
  return getOrCreateGlobalContext(getContextKey(plugin));
};
